import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ActivityFeeService } from '../activity-fee.service';
import { ActivityFee } from '../activity-fee';
import { ActivityFeeComponent } from '../activity-fee/activity-fee.component';

@Component({
    selector: 'app-activity-fee-list',
    templateUrl: './activity-fee-list.component.html',
    styleUrls: ['./activity-fee-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ActivityFeeListComponent implements OnInit {
	constructor(
		private activityFeeService: ActivityFeeService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = activityFeeService.statuses
	}



	// data
	@Input() activityId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	activityFees: any;
	activityFee: ActivityFee;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'activityFeeId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'season', header: 'Season', width: 'auto' },
		{ field: 'activityId', header: 'ActivityId', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.activityFeeId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-activityFee-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.activityId)
			{
				// show only activities that are assigned to this activityId
				let activityIdFilter = { 'activityId': { 'value': this.activityId, 'matchMode': 'in' } };
				Object.assign(event.filters, activityIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.activityFeeService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.activityFees = res.data.activityFees;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.activityFees = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(activityFee: ActivityFee) {
		try {
			this.formLoading = true;
			this.activityFeeService.update(activityFee)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.activityFees.map((activityFee, i) => {
							if (activityFee.activityFeeId === res.data.activityFee.activityFeeId) {
								this.activityFees[i] = res.data.activityFee;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(activityFee: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(activityFee));

			this.formLoading = true;
			this.activityFeeService.delete(activityFee.activityFeeId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.activityFees.splice(this.activityFees.indexOf(activityFee), 1);
						this.recordTotal = this.activityFees.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ActivityFee ' + activityFee.activityFeeId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ActivityFee ' + activityFee.activityFeeId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "60vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ActivityFee',
			activityId: this.activityId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityFeeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addActivityFeeCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(activityFee: ActivityFee) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "60vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			activityFee: activityFee,
			activityId: this.activityId,
			title: 'Edit ActivityFee'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityFeeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateActivityFeeCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteActivityFeeCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addActivityFeeCB(activityFee: ActivityFee) {
		console.log('Adding ActivityFee: ' + JSON.stringify(activityFee));
		// if we don't have a activityFees array yet...
		if (!this.activityFees) {
			this.activityFees = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.activityFees.unshift(activityFee);

		// no idea what this is but it is required to update the array
		this.activityFees = [...this.activityFees];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivityFee ' + activityFee.activityFeeId + ' Added', life: 3000 });
	}

	updateActivityFeeCB(activityFee: ActivityFee) {
		console.log('Updating ActivityFee: ' + JSON.stringify(activityFee));
		let itemIndex = this.activityFees.findIndex((item: any) => item.activityFeeId === activityFee.activityFeeId);
		this.activityFees[itemIndex] = activityFee;

		// no idea what this is but it is required to update the array
		this.activityFees = [...this.activityFees];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivityFee ' + activityFee.activityFeeId + ' Updated', life: 3000 });
	}

	deleteActivityFeeCB(activityFee: ActivityFee) {
		console.log('Removing ActivityFee: ' + activityFee);
		this.activityFees.splice(this.activityFees.indexOf(activityFee), 1);
		this.recordTotal = this.activityFees.length;

		// no idea what this is but it is required to update the array
		this.activityFees = [...this.activityFees];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivityFee ' + activityFee.activityFeeId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.activityFees ? this.first === (this.activityFees.length - this.rows) : true; }
	isFirstPage(): boolean { return this.activityFees ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(activityFee: any) {
		if (activityFee?.status) {
			const status = this.statuses.find((e: any) => e.value == activityFee.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
